import { DatePipe } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ExcelService } from 'src/app/service/excel.service';
import { SurveyService } from '../service/survey.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { UtilityService } from 'src/app/service/utility.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReasonListModalComponent } from '../Reason-list/reason-list-modal/reason-list-modal.component';
import { ThisReceiver } from '@angular/compiler';
import { ReportService } from '../../reports/service/report.service';
import { Router } from '@angular/router';
import { ClientListInfoService } from 'src/app/_metronic/layout/core/client-list-info.service';
import { NotifierService } from 'angular-notifier';


@Component({
  selector: 'app-completion-report',
  templateUrl: './completion-report.component.html',
  styleUrls: ['./completion-report.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers:[DatePipe]
})
export class CompletionReportComponent implements OnInit ,AfterViewInit, OnDestroy {
  dateRangeForm: FormGroup;
  DAY = 86400000;
  public reasonList:any = [];
  public dateResetDone:boolean = true
  @ViewChild('startPicker') pickerStart: any;
  @ViewChild('endPicker') pickerEnd: any;

  public searchText:string='';
  
  public hasFilter:boolean=false;
  dateRangeConfig: FlatpickrOptions = {
    mode: 'range',
    enableTime: false,
    dateFormat: 'd-m-Y',
    dateStrFormat:'d-m-Y',
    defaultDate:this.SetDateRange()
  };
  startOptions: FlatpickrOptions = {
    mode: 'single',
    dateFormat: 'd-m-Y',
    dateStrFormat:'d-m-Y',
    // defaultDate: new Date(Date.now() - (this.DAY*30)),
    defaultDate: this.getDefaultDate(),
    maxDate: new Date(),
  };

  endOptions: FlatpickrOptions = {
    mode: 'single',
    dateFormat: 'd-m-Y',
    dateStrFormat:'d-m-Y',
    defaultDate: new Date(),
    minDate: new Date(Date.now() - (this.DAY*30)),
    maxDate: new Date(),
  };

  public reports:any=[];
  public reportQuery:any ={};
  public reportResult:any ={};
  public isApiCallDone:boolean=false;
  public reportHeadersContainer:any=[];
  // public selectedClients:any = [];
  // public selectedClient :any = {};
  public selectedClientUUID :string = '';
  // public selectedStatusItems:any = [];
  public selectedResponseStatusItems:any = [];
  public selectedPaymentStatusItems:any = [];
  public dropdownSettings:IDropdownSettings = {};  
  public dropdownStatusSettings:IDropdownSettings = {};  
  public dropdownClientSettings:IDropdownSettings = {};  
  public dropdownClientSettings1:IDropdownSettings = {};  
  public accessRoles:any = {};
  public switchUserAccess:boolean = false;
  public clientSelectedUser:boolean = false;
  public defaultSelectedUser:boolean = false;
  dropdownSurveyList: any[] = [];
  responseStatusList: any[] = [];
  paymentStatusList: any[] = [];
  dropdownClientList: any[] = [];
  selectedItems: any[] = [];
  public SearchByContainer:any = [];
  public searchBy:string = "";
  public ShowSearchBar:boolean = false;
  // dropdownSettings:IDropdownSettings = {};  // scroll pagination

  throttle = 150;
  scrollDistance = 1;
  pageData = {pageNo: 1, page_size: 50};

  constructor(
    private fb: FormBuilder,
    public datepipe: DatePipe,
    private cd: ChangeDetectorRef,
    public surveyService:SurveyService,
    public excelService:ExcelService,
    private readonly renderer: Renderer2,
    public utility:UtilityService,
    public matDialoge:NgbModal,
    public route:Router,
    public reportService:ReportService,
    public notifier:NotifierService,
    public clientService:ClientListInfoService,
    ) { 
        this.isApiCallDone = false;
        this.dateRangeForm = fb.group({
          dateRange: new Date(),
          // start:new Date(Date.now() - (this.DAY*30)),
          start:this.getDefaultDate(),
          end:new Date()
        });
        // this.dateRangeForm = fb.group({
        //   dateRange: new Date(),
        //   start:'',
        //   end:''
        // });
        this.reports = [];
        // Start Date Changes
        this.dateRangeForm.controls.start.valueChanges.subscribe(changes => {
          if (!changes[0]) return;
          const selectedDate = changes[0].getTime();
          this.pickerEnd.flatpickr.set({
            minDate: new Date(selectedDate),
          });
        });

        // End Date Changes
        this.dateRangeForm.controls.end.valueChanges.subscribe(changes => {
          console.log('end: ', changes);
          if (!changes[0]) return;
          const selectedDate = changes[0].getTime();
          this.pickerStart.flatpickr.set({
            maxDate: new Date( selectedDate)
          });

        });
        this.applyFilter();
      }

  ngOnDestroy(): void {
    this.utility.resetSortColumn();
  }


  getDefaultDate(){
    let date = new Date();
    date.setDate(1);
    date.setHours(0,0,0,0);
    return date
  }



  ngAfterViewInit(): void {
    // const rows = this.renderer.createElement('div');
    // this.selectionRef = document.getElementById('tableID') as HTMLElement;
  }


  checkSwitchUserAccess(){
    this.accessRoles = JSON.parse(localStorage.getItem('access') || '');
    this.accessRoles = this.accessRoles.access_rules;
    if(this.accessRoles && this.accessRoles.header && this.accessRoles.header.switch_user){
      this.switchUserAccess = true;
      this.getAllClients()
    }
  }
  ngOnInit(): void {
    this.pageData['pageNo'] = 1;

    this.selectedItems = [];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'survey_uuid',
      textField: 'survey_name',
      allowSearchFilter: true,
      enableCheckAll:true,
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
    };
    this.dropdownStatusSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'value',
      allowSearchFilter: true,
      enableCheckAll:true,
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
    };
    this.dropdownClientSettings = {
      singleSelection: false,
      idField: 'uuid',
      textField: 'name',
      allowSearchFilter: true,
      enableCheckAll:false,
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
    };
    // this.dropdownClientSettings1 = {
    //   singleSelection: true,
    //   idField: 'uuid',
    //   textField: 'name',
    //   allowSearchFilter: true,
    //   enableCheckAll:false,
    // };
    this.getSurveyList();
    this.checkSwitchUserAccess();
    this.specifiedUser();
    this.setSearchByContainer();
  }


  setSearchByContainer(){
    this.SearchByContainer = [];
    if(this.accessRoles.reports && this.accessRoles.reports.completion_report && this.accessRoles.reports.completion_report.search){
      let obj = this.accessRoles.reports.completion_report.search;
      let arr:any = [];
      Object.keys(obj).forEach((va:any) =>{
        if(obj[va]){
          arr.push(va);
        }
      })
      this.SearchByContainer = arr;
    }
  }

  specifiedUser(){
    if(localStorage.getItem('clientDetails')){
      let user:any = localStorage.getItem('clientDetails');
      user = JSON.parse(user);
      if(user.uuid){
        this.clientSelectedUser = true;
        this.defaultSelectedUser = false;
      }
      else
      {
        this.clientSelectedUser = false;
        this.defaultSelectedUser = true;
      }
    }
  }

  // scroll pagination
  onScrollPagination() {
    this.pageData['pageNo']++;
    if (this.reportResult && this.reportResult.total_page >= this.pageData['pageNo']) {
      this.reportQuery.filter.page_no = this.pageData['pageNo'];
      this.getReports(this.reportQuery);
    }
  }

  SetDateRange(){
    let date = new Date();
    if(date.getMonth() > 1)
    {
      date.setMonth(date.getMonth()-1);
    }
    else
    {
      date.setFullYear(date.getFullYear() -1);
      date.setMonth(11);
    }
    let currDate = new Date();
    let priorDate = new Date(new Date().setDate(new Date().getDate() - 30));
    let str = "";
    str += this.datepipe.transform(priorDate, 'dd-MM-yyyy') || '';
    str += ' to ';
    str += this.datepipe.transform(currDate, 'dd-MM-yyyy') || '';
    return str;
  }

  getSurvayIdFilter(){
    let survey_ids_filter = ''
    this.selectedItems.forEach((item:any, index:number) =>{
      survey_ids_filter += item.survey_uuid;
      if (index < this.selectedItems.length -1) {
        survey_ids_filter += ','
      }
    })
    return survey_ids_filter;
  }

  getIdFilterStr(slectedList:any[],key:string){
    let str = ''
    slectedList.forEach((item:any, index:number) =>{
      
      str += item[key];
      if (index < slectedList.length -1) {
        str += ','
      }
    })
    return str;
  }

  download(){
    this.getReasonList();
    let filename = "report_"+this.datepipe.transform(this.reportQuery.filter.start_date, 'dd-MM-yyyy')+"_"+this.datepipe.transform(this.reportQuery.filter.end_date, 'dd-MM-yyyy')
    let query = {}
    if (this.reportQuery.filter.survey_ids_filter && this.reportQuery.filter.survey_ids_filter != '') {
      query = {
        "start_date":this.reportQuery.filter.start_date, 
        "end_date":this.reportQuery.filter.end_date, 
        "download":true,
        "survey_ids_filter":this.reportQuery.filter.survey_ids_filter 
      }
    }else{
      query = {
        "start_date":this.reportQuery.filter.start_date, 
        "end_date":this.reportQuery.filter.end_date, 
        "download":true
      }
    }

    // console.log("query is ", query)
    this.surveyService.onDownloadCompletionReport(query)
    .subscribe({
      next :(res:any) =>{
        if (res['status'] == 1) {
          let report = res.result
          let reportObj = {'report':report, 'reasons':this.reasonList}
          this.excelService.exportMultipalJsonAsExcelFile(reportObj,filename)
          // this.excelService.exportJsonAsExcelFile(report,filename);
        }
      },
      error: (e) =>{
        console.log(e);
      }
    })
  }

  getReasonList(){
    this.surveyService.getReasonList()
    .subscribe({
      next: (res: any) => {
        if (res['status'] == 1) {
          this.reasonList = res['reasons'];
          this.reasonList = this.reasonList.map((va:any,index:any) => ({'Sl No.':index+1,'Reasons':va.label,'Brief':va.brief,'cases':va.cases.join(', ')}));
        }
      },error :(e) =>{
        console.log(e)
      }
    })
  }

  applyFilter(){
    this.pageData['pageNo'] = 1;
    // let survey_ids_filter = ''
    // if (this.selectedItems && this.selectedItems.length) {
    //   survey_ids_filter = this.getSurvayIdFilter()
    // }
    // if (survey_ids_filter && survey_ids_filter != '') {
    //   this.reportQuery = {
    //     "filter": {
    //         "start_date":"",
    //         "end_date" : "",
    //         "page_size":this.pageData['page_size'],
    //         "page_no":this.pageData['pageNo'],
    //         "survey_ids_filter":survey_ids_filter
    //       }
    //     }
    // }else{
    //   this.reportQuery = {
    //     "filter": {
    //         "start_date":"",
    //         "end_date" : "",
    //         "page_size":this.pageData['page_size'],
    //         "page_no":this.pageData['pageNo']
    //       }
    //     }
    // }

    this.reportQuery = {
      "filter": {
          "page_size":this.pageData['page_size'],
          "page_no":this.pageData['pageNo']
        }
      }


      if (this.searchBy && this.searchBy != '') {
        this.reportQuery['filter']['searchBy'] = this.searchBy;
      }
      if (this.selectedItems && this.selectedItems.length) {
        this.reportQuery['filter']['survey_ids_filter'] = this.getSurvayIdFilter()
      }
      if (this.searchText && this.searchText != '' && this.searchText.length > 2) {
        this.reportQuery['filter']['search'] = this.searchText;
      }
      // if (this.selectedClients && this.selectedClients.length) {
      //   this.reportQuery['filter']['client_uuid'] = this.getIdFilterStr(this.selectedClients,'uuid')
      // }
 
      if (this.selectedClientUUID && this.selectedClientUUID != '') {
        console.log("selected =>",this.selectedClientUUID)
        this.reportQuery['filter']['clientUUIDs'] = this.selectedClientUUID
      }
      if (this.selectedResponseStatusItems && this.selectedResponseStatusItems.length) {
        console.log("this.selectedResponseStatusItems",this.selectedResponseStatusItems)
        this.reportQuery['filter']['response_status_filter'] = this.getIdFilterStr(this.selectedResponseStatusItems,'id')
      }
      if (this.selectedPaymentStatusItems && this.selectedPaymentStatusItems.length) {
        console.log("this.selectedPaymentStatusItems",this.selectedPaymentStatusItems)
        this.reportQuery['filter']['payment_status_filter'] = this.getIdFilterStr(this.selectedPaymentStatusItems,'id')
      }
      
    // this.reportQuery = {
    //   "filter": {
    //       "start_date":"",
    //       "end_date" : "",
    //       "page_size":this.pageData['page_size'],
    //       "page_no":this.pageData['pageNo']
    //     }
    //   }
    if (this.dateRangeForm.value.start != '') {
      this.reportQuery.filter['start_date'] = Array.isArray(this.dateRangeForm.value.start) ? this.datepipe.transform(this.dateRangeForm.value.start[0], 'yyyy-MM-dd 00:00:00') : this.datepipe.transform(this.dateRangeForm.value.start, 'yyyy-MM-dd 00:00:00');
    }
    if (this.dateRangeForm.value.end != '') {
      this.reportQuery.filter['end_date'] =  Array.isArray(this.dateRangeForm.value.end) ?  this.datepipe.transform(this.dateRangeForm.value.end[0], 'yyyy-MM-dd 23:59:59') : this.datepipe.transform(this.dateRangeForm.value.end, 'yyyy-MM-dd 23:59:59');
    }
    // this.reportQuery.filter.start_date = Array.isArray(this.dateRangeForm.value.start) ? this.datepipe.transform(this.dateRangeForm.value.start[0], 'yyyy-MM-dd hh:mm:ss') : this.datepipe.transform(this.dateRangeForm.value.start, 'yyyy-MM-dd hh:mm:ss');
    // this.reportQuery.filter.end_date =  Array.isArray(this.dateRangeForm.value.end) ?  this.datepipe.transform(this.dateRangeForm.value.end[0], 'yyyy-MM-dd hh:mm:ss') : this.datepipe.transform(this.dateRangeForm.value.end, 'yyyy-MM-dd hh:mm:ss');
    this.dateResetDone = true;
    // if (this.dateRangeForm.value.dateRange && Array.isArray(this.dateRangeForm.value.dateRange)) {
    //   this.reportQuery.filter.start_date = this.datepipe.transform(this.dateRangeForm.value.dateRange[0], 'yyyy-MM-dd hh:mm:ss') || '';
    //   this.reportQuery.filter.end_date = this.datepipe.transform(this.dateRangeForm.value.dateRange[1], 'yyyy-MM-dd hh:mm:ss') || '';
    // }else if(this.dateRangeForm.value.dateRange && !Array.isArray(this.dateRangeForm.value.dateRange)){
    //   let priorDate = new Date(new Date().setDate(new Date().getDate() - 30));
    //   this.reportQuery.filter.start_date = this.datepipe.transform(priorDate, 'yyyy-MM-dd hh:mm:ss') || '';
    //   this.reportQuery.filter.end_date = this.datepipe.transform(this.dateRangeForm.value.dateRange, 'yyyy-MM-dd hh:mm:ss') || '';
    // }
    this.checkFilter();
    console.log("this.this.reportQuery['filter'] ====>",this.reportQuery['filter'])
    this.getReports(this.reportQuery);
  }

  checkFilter(){
    // console.log("this.reportQuery",this.reportQuery)
    if (Object.keys(this.reportQuery['filter']).includes('search')) {
      this.hasFilter = Object.keys(this.reportQuery['filter']).length > 3;
    }else{
      this.hasFilter = Object.keys(this.reportQuery['filter']).length > 2;
    }
  } 

  resetFilter(){
    this.selectedItems = []
    // this.selectedStatusItems = []
    this.selectedResponseStatusItems = []
    this.selectedPaymentStatusItems = [];
    this.selectedClientUUID = '';
    // this.selectedClients = []
    // this.selectedClient = {}
    this.dateRangeForm.patchValue({
      dateRange:new Date(Date.now() - (this.DAY*30)),
      // start:new Date(Date.now() - (this.DAY*30)),
      start:this.getDefaultDate(),
      end:new Date(),
    })
    // this.dateRangeForm.patchValue({
    //   dateRange:'',
    //   start:'',
    //   end:'',
    // })
    this.dateResetDone = false;
    this.cd.detectChanges()
    this.applyFilter()
  }

  getReports(query:any){
    this.surveyService.getCompletionReport(query)
    .subscribe({
      next :(res:any) =>{
        if (res['status'] == 1) {
          this.reportResult = res;
          if (res.page_no == 1) {
            this.reports = res.result;
          }else{
            this.reports = [...this.reports, ...res.result];
          }

          if(res.respons_status_arr){
            this.responseStatusList = res.respons_status_arr
          }
          if(res.payment_status_arr){
            this.paymentStatusList = res.payment_status_arr
          }
          // this.responseStatusList = res.respons_status_arr
          // this.paymentStatusList = res.payment_status_arr
          this.cd.detectChanges();
        }
      },
      error: (e) =>{
        console.log(e);
        // this.isApiCallDone = true
        // this.cd.detectChanges();
      },
      complete:() => {
        this.isApiCallDone = true;
        this.reportHeadersContainer = [];
        this.setHeadersForReports();
        this.cd.detectChanges();
      }
    })
  }


  setHeadersForReports(){
    this.reportHeadersContainer = Object.keys(this.reports[0]).length ? Object.keys(this.reports[0]) :[];
    this.reportHeadersContainer.unshift('SL');
    let arr = this.reportHeadersContainer;
    let header_arr = []
    for(let i=0;i<arr.length;i++){
      switch (arr[i]){
        case 'SL':
          header_arr[0] = 'Sl No.';
          break;
        case 'survey_name':
          header_arr[3] = 'Survey ID';
          break;
        case 'pid':
          header_arr[1] = 'PID';
          break;
        case 'start_time':
          header_arr[10] = 'Start Time';
          break;
        case 'end_time':
          header_arr[11] = 'End Time';
          break; 
        case 'cpi':
          header_arr[5] = 'CPI';
          break; 
        case 'loi':
          header_arr[6] = 'LOI';
          break;           
        case 'response_status':
          header_arr[7] = 'Response Status';
          break; 
        case 'payment_status':
          header_arr[8] = 'Payment Status';
          break; 
        case 'rid':
          header_arr[2] = 'RID';
          break;
        case 'cags':
          header_arr[9] = 'CAG';
          break;
        case 'client_name':
          header_arr[4] = 'Client';
          break;

        default :
          header_arr[12] = ""  
      }
    }
    this.reportHeadersContainer = header_arr.filter((va:any) => (va ? true : false));
  }


  SetGridColumns(){
    let val = 'repeat(' + this.reportHeadersContainer.length + ',' + 'minmax(60px,120px)' + ')';
    // console.log(val);
    return val;
  }






  getSurveyList(){
    let status = "2"
    this.surveyService.getSurveyList(status)
    .subscribe({
      next :(res:any) =>{
        if (res['status'] == 1) {
          this.dropdownSurveyList = res.result
          this.cd.detectChanges();
        }
      },
      error: (e) =>{
        console.log(e);
      },
      complete:() => {
        this.isApiCallDone = true
        this.cd.detectChanges();
      }
    })
  }


  onItemSelect(item: any) {
    // console.log(item);
  }
  onSelectAll(items: any) {
    // console.log(items);

  }

  ReasonListModalPopup(){
    this.surveyService.showCagsDeatilsModal = false;
    this.surveyService.showReasonListModal = true;
    this.matDialoge.open(ReasonListModalComponent, { size:'xl',scrollable: true,centered:true,windowClass:'ReasonListModalComponent'});
  }


  CagsDeatailsModalOpen(cags:any){
    this.surveyService.showCagsDeatilsModal = true;
    this.surveyService.showReasonListModal = false;
    this.surveyService.surveyCagsDeatils = cags
    this.matDialoge.open(ReasonListModalComponent, { size:'lg',scrollable: true,centered:true,windowClass:'PopupComponentComponent'});
  }

  paymentStatusModalOpen(rid:any){
    this.surveyService.responseReportType = 'complete';
    this.surveyService.responseDetails_rid = rid;
    this.surveyService.showCagsDeatilsModal = false;
    this.surveyService.showReasonListModal = false;
    this.surveyService.responseStatusModalOpen = false;
    this.surveyService.paymentStatusModalOpen = true;
    this.matDialoge.open(ReasonListModalComponent, { size:'lg',scrollable: true,centered:true,windowClass:'PopupComponentComponent'});
  }

  responseStatusModalOpen(rid:any){
    this.surveyService.responseReportType = 'complete';
    this.surveyService.responseDetails_rid = rid;
    this.surveyService.showCagsDeatilsModal = false;
    this.surveyService.showReasonListModal = false;
    this.surveyService.paymentStatusModalOpen = false;
    this.surveyService.responseStatusModalOpen = true;
    this.matDialoge.open(ReasonListModalComponent, { size:'lg',scrollable: true,centered:true,windowClass:'PopupComponentComponent'});
  }

  getSelectedItems(len:number){
    if (this.selectedItems && this.selectedItems.length > 0) {
      let items = [];
      items = this.selectedItems.map(item => item.survey_name);
      let str = items.join(', ')
      if (str.length > len) {
        let isCommaAtBorder = str.charAt(len) == ',';
        // console.log(`The character at index ${len} is ${str.charAt(len)}`)
        str = this.utility.getSubStr(str,len,{isDots:true});
        let count = str.split(",").length -1;
        count = isCommaAtBorder ? count+1 : count;
        if ((items.length - count) > 0) {
          return str + " +"+ (items.length - count)
        }else{
          return str 
        }
      }else{
        return str
      }
    }else{
      return ""
    }
    
  }


  getSelectedItems1(list:any[],key:string,len:number){
    if (list && list.length > 0) {
      let items = [];
      items = list.map(item => item[key]);
      let str = items.join(', ')
      if (str.length > len) {
        let isCommaAtBorder = str.charAt(len) == ',';
        str = this.utility.getSubStr(str,len,{isDots:true});
        let count = str.split(",").length -1;
        count = isCommaAtBorder ? count+1 : count;
        if ((items.length - count) > 0) {
          return str + " +"+ (items.length - count)
        }else{
          return str 
        }
      }else{
        return str
      }
    }else{
      return ""
    }
  }

  onSearchByChange(){
    if (this.searchText.length > 0) {
      this.applyFilter();
    }else if(this.searchText == ''){
      this.applyFilter();
    }else{
      delete this.reportQuery['filter'].search
      this.checkFilter();
    }
  
  }


  onSearchChange(){
    if (this.searchText.length > 2) {
      this.applyFilter();
    }else if(this.searchText == ''){
      this.applyFilter();
    }else{
      delete this.reportQuery['filter'].search
      this.checkFilter();
    }
  }



  searchByChange(){
    if(this.searchBy && this.searchBy != '')
    {
      this.ShowSearchBar = true;
      this.searchText = '';
    }
    else
    {
      this.ShowSearchBar = false;
    }
    this.onSearchByChange();
  }



      
  

  getAllClients(){
    this.clientService.getAllClients().subscribe({
      next: (res: any) =>{
        if (res['status'] == 1) {
          let arr = res['result'];
          this.clientService.clientList = arr;
          this.dropdownClientList = arr;
          this.cd.detectChanges();
        }
      },error :(e) =>{
        console.log(e)
      }
    })
  }
  
  redirectPageSurveyDetails(survey:any){
    this.surveyService.redirectFromInventory = false;
    this.surveyService.redirectFromCompletion = true;
    this.surveyService.redirectFromCompletionSurveyDetails = survey;
    localStorage.removeItem('selected_container');
    localStorage.setItem('redirectFromCompletionSurveyDetails',JSON.stringify(survey));
    // this.route.navigate(['/survey/details/',survey.survey_id]);
  }



  CreateRedirectLink(survey_id:any){
    return `${location.origin}/survey/details/${survey_id}`;
  }

  placeholderShow(){
    // return `Search by ${this.SearchByContainer.join(',')}`;
    return `Search`;

  }


  formatSurveyrid(text:any){
    if(text.length < 10)
    {
      return text;
    }
    else
    {
      return text.substr(0, 10) + '...';
    }
  }


  copyClipBoard(type:any,id:any){
    this.utility.copyOnClick(id,type);
    // this.notifier.notify('success',`${type} copy successfully`);
  }

}
